import { IState } from "./state";

// ! Add migration steps after changing state structure
export const migrationSteps: Record<number, (state: IState) => IState> = {
  1: (state: IState) => {
    if (!state.settings.language) {
      state.settings.language = "en";
    }
    return state;
  },
  // Add more migration steps as new versions come out
  2: (state: IState) => {
    if (!state.settings.isSourceDataName) {
      state.settings.isSourceDataName = false;
    }
    return state;
  },

  3: (state: IState) => {
    if (!state.loginTimestamp) {
      state.loginTimestamp = 0;
    }
    return state;
  },

  4: (state: IState) => {
    if (!state.didShowWelcome) {
      state.didShowWelcome = false;
    }
    return state;
  },
};

export const migrateState = (loadedState: IState, currentVersion: number) => {
  let state = { ...loadedState };
  const loadedVersion = state.version || 0;

  // apply each migration step sequentially until the current version is reached
  for (let version = loadedVersion + 1; version <= currentVersion; version++) {
    if (migrationSteps[version]) {
      state = migrationSteps[version](state);
    }
  }

  state.version = currentVersion;

  return state;
};
